// SEOServiceProvider.tsx
import { getAll } from '../services/CRUDServiceProvider';
import { PaginationRequest } from '../types/pagination';

let url_path = 'seo-meta-tags';

export interface Meta {
    key: string;
    value: string;
}

export interface MetaTag {
    name: string;
    title: string;
    description: string;
    keywords: string;
    type: string;
    page: string;
    url: string;
    image: string;
    metas: Meta[];
};

export const getAllMetaTags = async (pagination: PaginationRequest): Promise<MetaTag[]> => {
    //console.log(token);
    console.log(url_path);
    try {
        const response = await getAll<any>(url_path, pagination, undefined);
        return response.data;
    } catch (error) {
        throw error;
    }
};
